import getMinutes from './get-minutes';

export { getMinutes };

export default getMinutes;
